import React from 'react';
import "../../Css/chartProduct.css";
import { useStateValue } from '../../Middleware/context/StateProvider';

function CartProduct({ id,Produto,tipo,description, price, quantity, img,taxa }) {
  const { dispatch } = useStateValue();

  return (
    <div className="chart_product">
      <img className="chart_productImage" src={img} alt={tipo} />

      <div className="chart_product_info">
        <strong>{Produto}</strong>
        <p>{description}</p>

        <strong>Kz {((price * quantity)+taxa).toLocaleString()}</strong>

        <div className="btncalc">
          <button onClick={() => dispatch({ type: 'Decrease_TO_BASKET', item: { id } })}>−</button>
          <span>{quantity}</span>
          <button onClick={() => dispatch({ type: 'Increase_TO_BASKET', item: { id } })}>+</button>
        </div>

        <button onClick={() => dispatch({ type: 'REM_FROM_BASKET', item: { id } })}>
          Remover
        </button>
      </div>
    </div>
  );
}

export default CartProduct;

